import React, { useState, useEffect } from 'react';
import TopLinkButton from 'components/button/TopLinkButton';
import { useAuthContext } from 'components/special/oAuthProvider';
import { useLocale } from 'components/special/LanguageProvider';


const OTHERWEB_URL = process.env.REACT_APP_ILWEB_URL ? process.env.REACT_APP_ILWEB_URL.replace(/\/$/, '') : '';

const myCustomMenu = [
  // {    
  //   label: "Yfirlitsmynd",
  //   url: "/demo",
  //   exact : true,
  //   subscriber : ["4307"]
  // },
  {    
    label: "Kröfur",
    //url: "/main/claims",
    url: OTHERWEB_URL + "/claims/",
    exact : false 
  },
  {    
    label: "Aðilar",
    //url: "/main/subjects",
    url: OTHERWEB_URL + "/subjects/",
    exact : true
  },
  {    
    label: "Kröfuhafar",
    //url: "/main/subjects",
    url: OTHERWEB_URL + "/creditors/",
    exact : true
  },
  {    
    label: "Dagbók",
    //url: "/main/dairies",
    url: OTHERWEB_URL + "/diary/",
    exact : true
  }
];


export default () => {
  const [products, setProducts] = useState([]);
  const { user, isAuthenticated } = useAuthContext();
  const { t } = useLocale();
    
const isAuthorizedForSubscriber = (user, item) =>{
    if (item.subscriber && item.subscriber.length > 0){
      if (item.subscriber.includes(user.s_id)){
        return item;
      }
      return null;
    }
    return item;
  }

  const isAuthorized = (user, item) =>{
    if (item.role && item.role.length > 0){
      //Check if the role is with the user.          
      for (let j = 0; j < item.role.length; j++) {
        const itemRole = item.role[j];
        if (user.role.includes(itemRole)){            
          return isAuthorizedForSubscriber(user, item);            
        }
      }
      return null;
    }
    return isAuthorizedForSubscriber(user, item);        
  }

  const authorizeList = (user, menuList) =>{
    let list = [];        
    menuList.forEach(item => {
      item.label = t(item.label);
      if (isAuthenticated){
        let menuItem = isAuthorized(user, item);
        if (menuItem != null){
          list.push(menuItem);
        }
      }
    });
    return list;
  }

  useEffect(() => {       
      let list = authorizeList(user, myCustomMenu);

      list.push(() => (
        <div>
          <TopLinkButton label={t("Nýskrá kröfu")}
          // url="/main/claims/create"
          url={OTHERWEB_URL + "/claim-create/subjects/"}
          />          
        </div>
      ));

      setProducts(list);    
  }, []);

  return products;
};
